export const API_URL =
  process.env.GATSBY_TENANT_API_URL ||
  "https://f14nr6zwf2.execute-api.ap-southeast-1.amazonaws.com";

export const WORKSPACE_SUFFIX =
  process.env.GATSBY_WORKSPACE_SUFFIX || ".bimeco.io";

export const COOKIE_DOMAIN =
  process.env.GATSBY_COOKIE_DOMAIN || ".bimeco.io";

export function isLocalHost(hostname: string) {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname.endsWith(".local");
}

export function isWorkspaceHost(hostname: string) {

  if (!hostname) return false;
  const apex = WORKSPACE_SUFFIX.replace(/^\./, "");
  return hostname.endsWith(WORKSPACE_SUFFIX) && hostname !== apex;
}

export function resolvePublicHost(hostname: string) {

  const env = process.env.GATSBY_PUBLIC_HOST;
  if (env && env.trim()) return env.trim();

  if (!hostname) return "";

  if (isWorkspaceHost(hostname)) return WORKSPACE_SUFFIX.replace(/^\./, "");

  return hostname;
}

export const PUBLIC_HOST =
  typeof window !== "undefined"
    ? resolvePublicHost(window.location.hostname)
    : (process.env.GATSBY_PUBLIC_HOST || "");

export function publicOrigin() {
  if (typeof window === "undefined") return `https://${PUBLIC_HOST}`;
  if (isLocalHost(window.location.hostname)) return window.location.origin; // keeps :8000

  if (isWorkspaceHost(window.location.hostname)) return `https://${WORKSPACE_SUFFIX.replace(/^\./, "")}`;

  return window.location.origin;
}

export function tenantHost(tenantSlug: string) {
  return `${tenantSlug}${WORKSPACE_SUFFIX}`;
}

export function publicBrandUrl(tenantSlug: string) {
  return `${publicOrigin()}/brands/${tenantSlug}`;
}

export function publicAssetUrl(tenantSlug: string, assetId: string) {
  return `${publicOrigin()}/brands/${tenantSlug}/brands/${tenantSlug}/assets/${assetId}`;
}

export function workspaceAssetUrl(tenantSlug: string, assetId: string) {
  return `https://${tenantHost(tenantSlug)}/assets/${assetId}`;
}
